import is from 'is_js';
import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';

export const FETCH_PERSONALISED_HOMEWORK_REQUEST = 'FETCH_PERSONALISED_HOMEWORK_REQUEST';
export const FETCH_PERSONALISED_HOMEWORK_SUCCESS = 'FETCH_PERSONALISED_HOMEWORK_SUCCESS';
export const FETCH_PERSONALISED_HOMEWORK_FAILURE = 'FETCH_PERSONALISED_HOMEWORK_FAILURE';
export const SUBMIT_PERSONALISED_HOMEWORK_REQUEST = 'SUBMIT_PERSONALISED_HOMEWORK_REQUEST';
export const SUBMIT_PERSONALISED_HOMEWORK_SUCCESS = 'SUBMIT_PERSONALISED_HOMEWORK_SUCCESS';
export const SUBMIT_PERSONALISED_HOMEWORK_FAILURE = 'SUBMIT_PERSONALISED_HOMEWORK_FAILURE';
export const DELETE_PERSONALISED_HOMEWORK_REQUEST = 'DELETE_PERSONALISED_HOMEWORK_REQUEST';
export const DELETE_PERSONALISED_HOMEWORK_SUCCESS = 'DELETE_PERSONALISED_HOMEWORK_SUCCESS';
export const DELETE_PERSONALISED_HOMEWORK_FAILURE = 'DELETE_PERSONALISED_HOMEWORK_FAILURE';
export const PUBLISH_PERSONALISED_HOMEWORK_REQUEST = 'PUBLISH_PERSONALISED_HOMEWORK_REQUEST';
export const PUBLISH_PERSONALISED_HOMEWORK_SUCCESS = 'PUBLISH_PERSONALISED_HOMEWORK_SUCCESS';
export const PUBLISH_PERSONALISED_HOMEWORK_FAILURE = 'PUBLISH_PERSONALISED_HOMEWORK_FAILURE';

import PersonalisedHomework from './model';

const buildApiTargetDescriptor =
  (personalisedHomeworkId, isUpdate, isDelete) => {
    let path = '/personalised-homework';
    if (is.existy(personalisedHomeworkId)) {
      path += `/${personalisedHomeworkId}`;
    }
    let method = 'GET';
    if (isUpdate) {
      method = is.existy(personalisedHomeworkId) ? 'PUT' : 'POST';
    }
    if (isDelete) {
      method = 'DELETE';
    }
    return {
      url: buildUrl(path),
      method,
    };
  };

const buildPublishPersonalisedHomeworkUrl =
  (phId) => buildUrl(`/personalised-homework/${phId}/publish`);

export function fetchPersonalisedHomeworkIfNeeded(personalisedHomeworkId, status) {
  return (dispatch, getState) => {
    const state = getState();
    const target = buildApiTargetDescriptor(personalisedHomeworkId);
    if (! ApiCall.shouldPerform(state, target)) {
      return false;
    }
    return dispatch(fetchPersonalisedHomework(personalisedHomeworkId, status));
  };
}

export function fetchPersonalisedHomework(personalisedHomeworkId, status) {
  return (dispatch) => {
    const target = buildApiTargetDescriptor(personalisedHomeworkId);
    const { url, method } = target;

    return dispatch(fetchPersonalisedHomeworkRequest()).payload
      .then((response) => dispatch(fetchPersonalisedHomeworkSuccess(response, status)))
      .catch((error) => dispatch(fetchPersonalisedHomeworkFailure(error)));

    function fetchPersonalisedHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
        personalisedHomeworkId,
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url,
        method,
        personalisedHomeworkId,
        status,
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PERSONALISED_HOMEWORK_FAILURE,
        error,
        url,
        method,
        personalisedHomeworkId,
      });
    }
  };
}

export function submitPersonalisedHomeworkModel(model) {
  return (dispatch) => {
    const target = buildApiTargetDescriptor(model.id, true);
    const { url, method } = target;

    // will be update with a real fix by applying mutiple content
    const tempModel = {
      sessionId: model.sessionId,
      studentIds: model.studentIds,
      contents: model.contents,
    };
    const request = fetch(url,
      {
        method,
        body: JSON.stringify(
          PersonalisedHomework.serialize(tempModel)
        ),
      }
    );

    return dispatch(fetchPersonalisedHomeworkRequest()).payload
      .then((response) => dispatch(fetchPersonalisedHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchPersonalisedHomeworkFailure(error)));

    function fetchPersonalisedHomeworkRequest() {
      return ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        model,
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url,
        method,
        model,
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_PERSONALISED_HOMEWORK_FAILURE,
        error,
        url,
        method,
        model,
      });
    }
  };
}

export function deletePersonalisedHomework(personalisedHomeworkId) {
  return (dispatch) => {
    const target = buildApiTargetDescriptor(personalisedHomeworkId, false, true);
    const { url, method } = target;
    const request = fetch(url,
      {
        method,
      }
    );

    return dispatch(fetchPersonalisedHomeworkRequest()).payload
      .then((response) => dispatch(fetchPersonalisedHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchPersonalisedHomeworkFailure(error)));

    function fetchPersonalisedHomeworkRequest() {
      return ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        personalisedHomeworkId,
      });
    }

    function fetchPersonalisedHomeworkSuccess(personalisedHomework) {
      return ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_SUCCESS,
        payload: personalisedHomework,
        url,
        method,
        personalisedHomeworkId,
      });
    }

    function fetchPersonalisedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: DELETE_PERSONALISED_HOMEWORK_FAILURE,
        error,
        url,
        method,
        personalisedHomeworkId,
      });
    }
  };
}

export function publishPersonalisedHomework(phId) {
  return (dispatch) => {
    const url = buildPublishPersonalisedHomeworkUrl(phId);
    const method = 'PUT';
    const request = fetch(url, { method });

    return dispatch(publishPersonalisedHomeworkRequest()).payload
      .then((response) => dispatch(publishPersonalisedHomeworkSuccess(response)))
      .catch((error) => dispatch(publishPersonalisedHomeworkFailure(error)));

    function publishPersonalisedHomeworkRequest() {
      return ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        phId,
      });
    }

    function publishPersonalisedHomeworkSuccess() {
      return ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_SUCCESS,
        url,
        method,
        phId,
      });
    }

    function publishPersonalisedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: PUBLISH_PERSONALISED_HOMEWORK_FAILURE,
        error,
        url,
        method,
        phId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/Personalised/actions.js